import countries from "../../../countries.json";

const forms = [
  {
    name: "Details",
    options: [
      {
        name: "Name",
        type: "input",
        form: {
          type: "text",
          name: "name",
          placeholder: "Supplier name",
          class: "",
          value: "",
          required: true,
        },
      },
    ],
  },
  {
    name: "Contacts",
    options: [
      {
        name: "Email",
        type: "input",
        form: {
          type: "text",
          name: "email",
          placeholder: "Supplier email",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Phone",
        type: "input",
        form: {
          type: "text",
          name: "phone",
          placeholder: "Supplier phone",
          class: "",
          value: "",
          required: true,
        },
      },
    ],
  },
  {
    name: "Catalog",
    options: [
      {
        name: "Catalog",
        type: "selectandadd",
        path: "/app/products/add",
        form: {
          mode: "multiple",
          name: "catalog",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Product catalog",
          api: "get-all-products",
          options: null,
          value: null,
          required: false,
        },
      },
    ],
  },
  {
    name: "Taxation",
    options: [
      {
        name: "Tax",
        type: "input",
        form: {
          type: "text",
          name: "tax",
          placeholder: "Supplier Tax Number",
          value: "",
        },
      },
    ],
  },
  {
    name: "Address",
    options: [
      {
        name: "Area",
        type: "input",
        form: {
          type: "text",
          name: "area",
          placeholder: "Supplier area address",
          class: "",
          value: "",
        },
      },
      {
        name: "City",
        type: "input",
        form: {
          type: "text",
          name: "city",
          placeholder: "Supplier city address",
          class: "",
          value: "",
        },
      },
      {
        name: "State",
        type: "input",
        form: {
          type: "text",
          name: "state",
          placeholder: "Supplier state address",
          class: "",
          value: "",
        },
      },
      {
        name: "Country",
        type: "select",
        form: {
          value: "Oman",
          name: "country",
          allowClear: false,
          showSearch: true,
          placeholder: "Oman",
          options: countries?.map((value, index) => ({
            value: value?.country,
            label: value?.country,
          })),
          required: false,
        },
      },
    ],
  },
  {
    name: "Trading Partner",
    options: [
      {
        name: "Linked Customer",
        type: "select",
        form: {
          name: "linked_customer",
          allowClear: false,
          showSearch: true,
          filterOption: false,
          placeholder: "Link to a customer (if same entity)",
          api: "get-all-customers",   // your existing customers dropdown API
          options: null,
          value: null,
          required: false,
        },
      },
    ],
  },
  {
    name: "Status",
    options: [
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;
